'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsSince;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/date/millisecondsSince.js
// module id = 1083
// module chunks = 0